export type InspectionTripType = 'PRE_TRIP' | 'POST_TRIP' | 'OTHER';

export enum DvirStatus {
  Completed = 'COMPLETED',
  AwaitingMechanic = 'AWAITING_MECHANIC',
  AwaitingSign = 'AWAITING_SIGN',
}
